import { appConstants } from "../_constants";
import moment from "moment/moment";


// const startDate = moment().startOf('month').format('YYYY-MM-DD');
// const endDate = moment().format("YYYY-MM-DD");
const today = new Date();
const currentDayOfWeek = today.getDay();
const diffToMonday = (currentDayOfWeek + 6) % 7;

const startDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() - diffToMonday);
const endDate = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate() + 6);

// const startDate = moment().startOf('month').format('YYYY-MM-DD');
// const endDate =  moment().format("YYYY-MM-DD");
let currentWeek = {
  startDate :moment(startDate).format('YYYY-MM-DD'),
  endDate: moment(endDate).format('YYYY-MM-DD'),
}
const initialState = {
  picker: currentWeek,
  type: appConstants.THISWEEK
}
export function dashboard(state = initialState, action) {


  switch (action.type) {
    case appConstants.PERIOD_PICKER_SELECTED:
      return {
        ...state,
        picker: action.value,
        type:action.val
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/_reducers/dashboard.reducer.js